import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../../components/Button/Button";
import useVoiceGeneration from "../../../hooks/useVoiceGeneration";
import { Zone } from "../../../types/project";
import { HumansParagraph } from "../../../types/humansProject";
import { GenerateAudioParams } from "../../../types/generateAudio";
import { getProjectAudio } from "../../../redux/reducers/projectReducer";
import { generateVoiceServer } from "../../../redux/actions/actorActions";
import { CircularProgress, PlayIcon, PauseIcon } from "../../../components/Icons/Icons";
import { checkIfZoneCached, checkIfZoneMatchNoAuthor, getAllZones } from "../../../lib/editorUtils";

interface Props {
  selectedZone?: Zone;
  currentParagraph: HumansParagraph;
  setIsPlayScript: (isPlayScript: boolean) => void;
}

const AIHumansScriptPlayer = ({ selectedZone, currentParagraph, setIsPlayScript }: Props) => {
  const { cachedZonesAudio } = useSelector(getProjectAudio);

  const generateZoneByIndex = (startZone: number) => {
    generateAudio({
      startZone,
    });
  };
  const dispatch = useDispatch();

  const {
    audioPlayer,
    onPlaying,
    onLoadedMetadata,
    onLoadStart,
    playing,
    isFetching,
    currentTime,
    duration,
    audioLoading,
    handlePlayClick,
  } = useVoiceGeneration({
    selectedZone: { ...currentParagraph?.data?.[0], actorId: currentParagraph?.actorId },
    paragraphs: [currentParagraph],
    generateZoneByIndex,
    setIsPlayScript,
  });

  const generateAudio = ({ startZone }: GenerateAudioParams) => {
    // const paragraphsModified = removeEmptyParagrahs(removeEmptyZones(JSON.parse(JSON.stringify(paragraphs))));
    const allZones = getAllZones([currentParagraph]);
    const currentZone = startZone || startZone === 0 ? allZones[startZone] : selectedZone;

    if (currentZone) {
      const currentZoneIndex = allZones.findIndex((zone) => checkIfZoneMatchNoAuthor(zone, currentZone));
      const finalCurrentZone = allZones[currentZoneIndex];
      const isZoneCached = checkIfZoneCached(finalCurrentZone, cachedZonesAudio);
      if (!isZoneCached) {
        dispatch(generateVoiceServer({ data: [{ ...finalCurrentZone }], isAIHuman: true }));
      } else {
        // TODO: sentry error - this exxception shouldn't be called
      }
    } else {
      // TODO: sentry error - this exxception shouldn't be called
    }
  };

  const handlePlaySceneScript = () => {
    handlePlayClick();
  };

  return (
    <Wrapper>
      <PlayScriptButton
        onClick={handlePlaySceneScript}
        text="Play script"
        icon={
          isFetching || audioLoading ? (
            <CircularProgress color="#F0F0F3" height={20} width={20} />
          ) : !playing || currentTime === duration ? (
            <PlayIcon />
          ) : (
            <PauseIcon />
          )
        }
      />
      <audio ref={audioPlayer} onTimeUpdate={onPlaying} onLoadedMetadata={onLoadedMetadata} onLoadStart={onLoadStart} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 16px;
`;

const PlayScriptButton = styled(Button)`
  width: 139px;
  height: 34px;
  border-radius: 5px;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 10px;
  & svg {
    height: 20px;
    width: 20px;
  }
  & .loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default AIHumansScriptPlayer;
